import { Check, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToId, imgUrl } from "@/lib/api";

const DEFAULT_PART = "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1000&q=80";
const DEFAULT_PRO = "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1000&q=80";

export default function Audiences({ settings = {} }) {
  const partImg = settings.hero_photo_audience_particuliers ? imgUrl(settings.hero_photo_audience_particuliers) : DEFAULT_PART;
  const proImg = settings.hero_photo_audience_pro ? imgUrl(settings.hero_photo_audience_pro) : DEFAULT_PRO;

  return (
    <section data-testid="audiences-section" className="py-16 sm:py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Pour qui ?</Eyebrow>
          <h2 className="mt-3 font-display font-semibold tracking-tight leading-snug text-2xl sm:text-3xl lg:text-4xl text-ink max-w-2xl">
            Particuliers &amp; professionnels
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 lg:grid-cols-2">
          <Reveal>
            <article data-testid="audience-particuliers" className="group h-full rounded-3xl overflow-hidden bg-white border border-line flex flex-col">
              <div className="h-56 sm:h-64 overflow-hidden">
                <img
                  src={partImg}
                  alt="Extérieur d'une maison entretenue"
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-7 sm:p-9 flex flex-col flex-1">
                <h3 className="font-display font-semibold text-xl sm:text-2xl text-ink">Votre extérieur, entretenu sans contrainte.</h3>
                <p className="mt-3 text-body2 leading-relaxed flex-1">
                  Jardin, terrain, maison, résidence secondaire ou besoin ponctuel : MARY SERVICES intervient selon vos besoins.
                </p>
                <button
                  onClick={() => scrollToId("#contact")}
                  data-testid="audience-particuliers-cta"
                  className="mt-6 inline-flex items-center gap-2 self-start rounded-full bg-forest text-cream text-sm font-semibold px-6 py-3 transition-all duration-200 hover:bg-pine hover:gap-3"
                >
                  Obtenir un devis
                  <ArrowRight className="h-4 w-4" />
                </button>
              </div>
            </article>
          </Reveal>

          <Reveal delay={0.1}>
            <article data-testid="audience-professionnels" className="group h-full rounded-3xl overflow-hidden bg-forest text-cream flex flex-col">
              <div className="h-56 sm:h-64 overflow-hidden">
                <img
                  src={proImg}
                  alt="Extérieurs d'un bâtiment professionnel"
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-7 sm:p-9 flex flex-col flex-1">
                <h3 className="font-display font-semibold text-xl sm:text-2xl">Des extérieurs propres, toute l'année.</h3>
                <p className="mt-3 text-cream/80 leading-relaxed">
                  Entreprises, commerces, agences immobilières, syndics, copropriétés, locations, collectivités et autres professionnels.
                </p>
                <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-2 flex-1">
                  {["Interventions ponctuelles", "Entretien régulier", "Remise en état", "Contrats récurrents", "Prestations sur mesure"].map((it) => (
                    <li key={it} className="flex items-center gap-2 text-sm text-cream/85">
                      <Check className="h-4 w-4 text-terra shrink-0" strokeWidth={3} />
                      {it}
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => scrollToId("#contact")}
                  data-testid="audience-pro-cta"
                  className="mt-6 inline-flex items-center gap-2 self-start rounded-full bg-terra text-white text-sm font-semibold px-6 py-3 transition-all duration-200 hover:bg-[#b05f41] hover:gap-3"
                >
                  Demander une offre professionnelle
                  <ArrowRight className="h-4 w-4" />
                </button>
              </div>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
